import React, { useEffect } from "react";
import TetoriRozeHero from "./TetoriRozeHero";
import TetoriRozeSurvey from "./TetoriRozeSurvey";
import TetoriRozeCompletion from "./TetoriRozeCompletion";
import TetoriRozeWelcome from "./TetoriRozeWelcome";

import "./tetoriRoze.scss";

const FONT_LINK_ID = "tetori-roze-2026-font";
const FONT_HREF =
   "https://fonts.googleapis.com/css2?family=Source+Serif+4:opsz,wght@8..60,400;8..60,500;8..60,600&display=swap";

// Every theme style is scoped under `.tr-theme`. The serif font is requested here rather than in
// index.html so no other page downloads it.
const TetoriRozeRoot = ({ children }) => {
   useEffect(() => {
      if (document.getElementById(FONT_LINK_ID)) {
         return;
      }
      const link = document.createElement("link");
      link.id = FONT_LINK_ID;
      link.rel = "stylesheet";
      link.href = FONT_HREF;
      document.head.appendChild(link);
   }, []);

   return (
      <div className="tr-page tr-theme">
         {children}
         <TetoriRozeWelcome />
      </div>
   );
};

const tetoriRoze2026 = {
   key: "tetori-roze-2026",
   // Preview puts this on its print root: react-to-print copies only that element, not the page.
   scopeClassName: "tr-theme",
   Root: TetoriRozeRoot,
   Hero: TetoriRozeHero,
   Survey: TetoriRozeSurvey,
   Completion: TetoriRozeCompletion
};

export default tetoriRoze2026;
